/**
 * AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
 *
 * Generated from: src/styles/_colors.scss
 * Generated at: 2026-01-15T21:10:03.478Z
 *
 * To regenerate: yarn generate:colors
 *
 * This file provides TypeScript access to color tokens for runtime usage.
 * For SCSS, use var(--step-*) directly instead.
 */

// Colors
export const cyanora = '#3cd0f5'
export const cyanoraDown = '#17b8e6'
export const futureFuscia = '#f66299'
export const futureFusciaDown = '#c03e6c'
export const coalMineCanary = '#fcd411'
export const coalMineCanaryDown = '#d9b20e'
export const amethyst = '#c772fd'
export const springtime = '#64da90'
export const black = '#000000'
export const blackV2 = '#111111'
export const darkGrey = '#222222'
export const midnight = '#222234'
export const midnightHaze = '#19191f'
export const rightBeforeBlack = '#292931'
export const elevenFortyFive = '#2f2f40'
export const rightBeforeMidnight = '#363649'
export const beforeMidnight = '#49495d'
export const buttonGray = '#4e4e4e'
export const white = '#ffffff'
export const whiteDown = '#e6e6e6'
export const offWhite = '#f6f7fa'
export const coldSteel = '#afb4c2'
export const borderButton = '#d5d2d9'
export const backgroundGray = '#e7e7e7'
export const gray950 = '#1c1c1c'
export const gray925 = '#1e1e1e'
export const gray900 = '#2a2a2a'
export const gray875 = '#2d2d2d'
export const gray850 = '#2d2d36'
export const gray800 = '#303030'
export const gray750 = '#333333'
export const gray700 = '#3a3a3a'
export const gray650 = '#3f3f3f'
export const gray600 = '#404040'
export const gray550 = '#4a4a4a'
export const gray500 = '#4f4f4f'
export const gray450 = '#505050'
export const gray400 = '#555555'
export const gray350 = '#616161'
export const gray300 = '#999999'
export const gray250 = '#9ca3af'
export const gray200 = '#9e9e9e'
export const gray150 = '#a9a9a9'
export const angry = '#ea3b28'
export const angryLight = '#e94d36'
export const angrySoft = '#f78279'
export const success = '#16a34a'
export const warningBrown = '#614e12'
export const orange = '#f59e0b'
export const orangeLight = '#ffb366'
export const turquoise = '#1b888f'
export const navyDeep = '#122861'
export const purple = '#8b5cf6'
export const periwinkle = '#799cf7'
export const orchid = '#ec4899'
export const pistachio = '#aad674'
export const raspberry = '#c94075'
export const hotPink = '#ff69b4'
export const magenta = '#ff00ff'
export const coldSteelMedium = 'rgba(175, 180, 194, 0.5)'
export const coldSteelOpaque = 'rgba(175, 180, 194, 0.8)'
export const whiteMedium = 'rgba(255, 255, 255, 0.5)'
export const midnightWeak = 'rgba(34, 34, 52, 0.1)'
export const grayWeak = 'rgba(34, 34, 52, 0.5)'
export const transparent = 'rgba(255, 255, 255, 0)'
export const transparentBlackV2 = 'rgba(17, 17, 17, 0.6)'
export const transparentDarkGrey = 'rgba(255, 255, 255, 0.08)'
export const blackMedium = 'rgba(0, 0, 0, 0.5)'
export const blackOverlay = 'rgba(0, 0, 0, 0.7)'
export const shadowSoft = '0 0 10px var(--step-midnight-weak)'
export const shadowButton = '0 1px 0 var(--step-midnight-weak)'
export const shadowModal = '0 4px 24px var(--step-black-medium)'
export const shadowCard = '0 2px 8px rgba(0, 0, 0, 0.1)'
export const shadowDropdown = '0 -1px 0 0 rgba(159, 159, 222, 0.18)'

// Gradients
export const linearGradientCyanoraToFutureFuscia =
    'linear-gradient( 90deg, #3cd0f5 0%, #f66299 100% )'
export const verticalGradientCyanoraToFutureFuscia =
    'linear-gradient( to bottom, #3cd0f5 0%, #f66299 100% )'
export const verticalGradientCyanoraToViolet =
    'linear-gradient( to bottom, #3cd0f5 0%, #c574fd 100% )'
export const diagonalGradientMidnightHazeToBlack =
    'linear-gradient( to bottom right, #19191f 40%, #000000 100% )'
export const sharpGradientTricolor =
    'linear-gradient( to left, #f66299 0% 32%, #3cd0f5 33% 66%, #fcd411 67% 99% )'
export const gradientPurpleOrchidOrange =
    'linear-gradient( 135deg, #8b5cf6 0%, #ec4899 50%, #f59e0b 100% )'
export const pinkBlackGradientVertical =
    'linear-gradient( 2deg, #111 23.2%, #e64286 100.93% )'
export const pinkPurpleGradient =
    'linear-gradient( 284deg, #7626c0 -25.56%, #be3d7f 100% )'
export const pinkPurpleGradientLighter =
    'linear-gradient( 284deg, #3cd0f5 -25.56%, #cc61ff 42.48%, #f6629d 100% )'
export const pinkPurpleGradientVertical =
    'linear-gradient( 45deg, #c84076 22.41%, #7726be 130.43% )'
export const purpleBlackGradientVertical =
    'linear-gradient( 2deg, #111 23.2%, #c772fd 159.07% )'
export const turquoiseBlueGradient =
    'linear-gradient( 85deg, #1b888f 2.14%, #26b7c1 80.05% )'

// Default export for dynamic access (e.g., variables[colorName])
const colorTokens = {
    cyanora,
    cyanoraDown,
    futureFuscia,
    futureFusciaDown,
    coalMineCanary,
    coalMineCanaryDown,
    amethyst,
    springtime,
    black,
    blackV2,
    darkGrey,
    midnight,
    midnightHaze,
    rightBeforeBlack,
    elevenFortyFive,
    rightBeforeMidnight,
    beforeMidnight,
    buttonGray,
    white,
    whiteDown,
    offWhite,
    coldSteel,
    borderButton,
    backgroundGray,
    gray950,
    gray925,
    gray900,
    gray875,
    gray850,
    gray800,
    gray750,
    gray700,
    gray650,
    gray600,
    gray550,
    gray500,
    gray450,
    gray400,
    gray350,
    gray300,
    gray250,
    gray200,
    gray150,
    angry,
    angryLight,
    angrySoft,
    success,
    warningBrown,
    orange,
    orangeLight,
    turquoise,
    navyDeep,
    purple,
    periwinkle,
    orchid,
    pistachio,
    raspberry,
    hotPink,
    magenta,
    coldSteelMedium,
    coldSteelOpaque,
    whiteMedium,
    midnightWeak,
    grayWeak,
    transparent,
    transparentBlackV2,
    transparentDarkGrey,
    blackMedium,
    blackOverlay,
    shadowSoft,
    shadowButton,
    shadowModal,
    shadowCard,
    shadowDropdown,
    linearGradientCyanoraToFutureFuscia,
    verticalGradientCyanoraToFutureFuscia,
    verticalGradientCyanoraToViolet,
    diagonalGradientMidnightHazeToBlack,
    sharpGradientTricolor,
    gradientPurpleOrchidOrange,
    pinkBlackGradientVertical,
    pinkPurpleGradient,
    pinkPurpleGradientLighter,
    pinkPurpleGradientVertical,
    purpleBlackGradientVertical,
    turquoiseBlueGradient,
}

export type ColorToken = keyof typeof colorTokens

export default colorTokens
